import React, { createContext, useState } from "react";

export const DriveContext = createContext();

const DriveProvider = ({ children }) => {
  const [socketData, setSocketData] = useState({
    messages: [],
  });


  return (
    <DriveContext.Provider
      value={{
        socketData,
        setSocketData,
      }}
    >
      {children}
    </DriveContext.Provider>
  );
};

export default DriveProvider;